import { Container, Row, Col, Image } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { FaPercentage, FaHandsHelping, FaQuestionCircle, FaCertificate, FaHistory } from "react-icons/fa";
import "./PetPage.scss";

import petsImg from "./img/PETS.png";
import petsGruposImg from "./img/celular-pet.png";
import petsCategoriesImg from "./img/dogs.png";
import logo from './img/logo-main.png';

const pixelId = '3978725122434215';

const baseURL = process.env.NODE_ENV === "production"
  ? process.env.REACT_APP_MERCADIM_BASE_URL_PRO
  : process.env.REACT_APP_MERCADIM_BASE_URL_DEV;

const whatsappLink = `${baseURL}entrar?tipo=pet`;

export default function PetPage() {
  useEffect(() => {
    if (!pixelId) return;
    const id = `fb-pixel-${pixelId}`;
    if (document.getElementById(id)) return;

    const script = document.createElement('script');
    script.id = id;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return (
    <>
      <Helmet title="Grupo PET - Caçadores de Ofertas" />

      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
        />
      </noscript>

      <section className="pet-hero">
        <div className="pet-hero-deco">
          <div className="pet-circle pet-circle-1" />
          <div className="pet-circle pet-circle-2" />
          <div className="pet-paw pet-paw-1" />
          <div className="pet-paw pet-paw-2" />
          <div className="pet-paw pet-paw-3" />
          <div className="pet-paw pet-paw-4" />
          <div className="pet-paw pet-paw-5" />
          <div className="pet-paw pet-paw-6" />
          <div className="pet-paw pet-paw-7" />
          <div className="pet-paw pet-paw-8" />
        </div>
        <div className="pet-hero-inner">
          <div className="pet-hero-left">
            <span className="pet-badge">GRUPOS DE OFERTAS</span>
            <h1 className="pet-title">
              TUDO PRO<br />SEU PET
            </h1>
            <a
              href={whatsappLink}
              rel="noopener noreferrer"
              className="pet-hero-cta"
            >
              QUERO PARTICIPAR
            </a>
          </div>
          <div className="pet-hero-right">
            <img src={petsImg} alt="Pets" className="pet-hero-img" />
          </div>
        </div>
      </section>

      <section className="pet-cta">
        <div className="pet-cta__card">
          <div className="pet-cta__phone">
            <img src={petsGruposImg} alt="Celular mostrando o grupo de ofertas Pet no WhatsApp" />
          </div>
          <div className="pet-cta__content">
            <h2>Falta pouco!</h2>
            <p>Clique no botão abaixo para participar:</p>
            <a href={whatsappLink} rel="noopener noreferrer" className="pet-cta__button">WhatsApp</a>
          </div>
        </div>
      </section>

      <section className="pet-categories">
        <div className="pet-categories__inner">
          <div className="pet-categories__content">
            <h2>Encontre os melhores preços de:</h2>
            <ul>
              <li>Ração e suplementos</li>
              <li>Brinquedos</li>
              <li>Higiene e limpeza</li>
              <li>Roupas</li>
              <li>Acessórios</li>
              <li>Medicamentos*</li>
            </ul>
          </div>
          <div className="pet-categories__visual">
            <img src={petsCategoriesImg} alt="Gato e cachorros representando categorias de produtos para pets" />
          </div>
          <small className="pet-categories__note">
            *Utilizar conforme orientação profissional
          </small>
        </div>
      </section>

      <section className="section-vantagens">
        <Container>
          <h2 className="title-vantagens text-center mb-5">QUAIS AS VANTAGENS?</h2>
          <Row className="text-center justify-content-center gx-4 gy-4">
            <Col xs={12} sm={6} md={3} className="d-flex">
              <div className="vantagem-card white flex-fill">
                <div className="icon-wrapper yellow-bg">
                  <FaCertificate className="icon-back" />
                  <FaPercentage className="icon-front" />
                </div>
                <h3>Promoções diárias</h3>
                <p>Receba no conforto da sua casa as melhores promoções dos principais varejistas do Brasil!</p>
              </div>
            </Col>
            <Col xs={12} sm={6} md={3} className="d-flex">
              <div className="vantagem-card yellow flex-fill">
                <div className="icon-wrapper custom-blue-bg">
                  <FaHandsHelping className="icon white large" />
                </div>
                <h3>Apoio na compra</h3>
                <p>Conte conosco para garantir que fará uma excelente compra, com segurança e pagando barato!</p>
              </div>
            </Col>
            <Col xs={12} sm={6} md={3} className="d-flex">
              <div className="vantagem-card white flex-fill">
                <div className="icon-wrapper yellow-bg">
                  <div className="icon-back-circle" />
                  <FaQuestionCircle className="icon-front question-icon" />
                </div>
                <h3>Tire suas dúvidas</h3>
                <p>Tá com alguma dúvida sobre alguma oferta? Entre em contato conosco que iremos lhe ajudar!</p>
              </div>
            </Col>
            <Col xs={12} sm={6} md={3} className="d-flex">
              <div className="vantagem-card yellow flex-fill">
                <div className="icon-wrapper white-bg">
                  <FaHistory className="icon white large" />
                </div>
                <h3>Histórico de preços</h3>
                <p>Tá em dúvida se um produto tá barato? Confira nosso histórico de preços no Telegram!</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-quem-somos">
        <div className="container">
          <Row className="align-items-center">
            <Col xs={12}>
              <h2 className="title-quem-somos text-center">QUEM SOMOS?</h2>
            </Col>
            <Col xs={12} md={6}>
              <div className="video-container">
                <iframe src="https://www.youtube.com/embed/VY2NEogxHVk" title="YouTube" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div className="quem-somos-text">
                <p>Nascemos em 2020 com objetivo de ajudar os consumidores brasileiros a economizar em suas compras na internet!</p>
                <p>Contamos com grupos de ofertas gerais no WhatsApp e Telegram, com mais de 200 mil membros totais, além de mais de 100 mil inscritos no YouTube!</p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <div className="footer">
        <Container className="text-center">
          <Image src={logo} alt="Caçadores de Ofertas" className="footer-logo" />
          <br /><br />
          <p className="footer-text">© Caçadores de Ofertas 2022-2025<br />Todos os direitos reservados.</p>
        </Container>
      </div>

    </>
  );
}
